import React from 'react';
import '../../../../styles/LookUpIssue.css';
import { FaqHomePageData } from '../../../types';
type LookUpIssueProps = {
  data: FaqHomePageData;
};
const LookUpIssue = ({ data }: LookUpIssueProps) => {
  return (
    <div className={`loopup_sctn`}>
      <p className="loopupTitle latoBlack blackText"> Look up issue by…</p>
      <ul className="loopupList">
        {data.topicList.map((item, index) => {
          return (
            <li key={index}>
              <p className="latoBlack blackText"> {item.topicName}</p>
              {item.subTopicList.map((item, index) => {
                return <p key={index}>{item.subTopicName}</p>;
              })}
              <p className="latoBold">
                <a
                  className="makeFlex hrtlCenter"
                  href={`https://www.makemytrip.com/railways/faq/topic-${item.topicSeoUrl}.html`}
                >
                  See more <span className=" arrowIcon"></span>
                </a>
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default LookUpIssue;
